export default __webpack_public_path__ + "static/media/location-marker.a9f3434c.svg";